import React from 'react';
import './FastSpinner.css';

/**
 * Web counterpart to mobile FastSpinner (~300ms/rev).
 * @param {'small'|'medium'|'large'|number} size
 * @param {string} color - CSS color for border
 */
export default function FastSpinner({ size = 'small', color = 'var(--button-bg, #5c4bd3)' }) {
  const dim =
    typeof size === 'number'
      ? Math.max(6, Math.round(size))
      : size === 'large'
        ? 36
        : size === 'medium'
          ? 22
          : 14;
  const borderWidth = dim <= 14 ? 1.5 : 2;
  return (
    <span className="fast-spinner-wrap" role="status" aria-label="Loading">
      <span
        className="fast-spinner"
        style={{
          width: dim,
          height: dim,
          borderWidth,
          borderColor: color,
        }}
      />
    </span>
  );
}
